import { useTheme } from "@emotion/react";
import { Person } from "@mui/icons-material";
import { Card, CardHeader, Typography } from "@mui/material";
import React from "react";

export default function TotalUsersCard({ users = [] }) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        "&:hover": {
          cursor: "pointer",
        },
        backgroundColor: theme.palette.mode === "dark" ? "#191B1F" : "#EFEFEF",
      }}
    >
      <CardHeader
        avatar={<Person fontSize="large" />}
        title="Total Users"
        titleTypographyProps={{
          variant: "h5",
          color: theme.palette.mode === "dark" ? "#8ba1b7" : "#000",
          py: 2,
          pr: 2,
        }}
        action={
          <Typography variant="h4" sx={{ py: 2 }}>
            {users.length || 0}
          </Typography>
        }
      />
    </Card>
  );
}
